import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 274;

export default makeStyles(() => ({
  drawerPaper: {
    zIndex: '3000',
    width: drawerWidth,
    marginTop: 64,
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    overflowY: 'scroll',
    height: 'calc(100vh - 64px)',
  },
  listItemText: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '18px',
    color: '#666666',
  },
  selectedlistItemText: {
    '&:hover': {
      color: '#DF0C36',
    },
  },
  listItem: {
    height: '48px',
    paddingLeft: '44px',
  },
  selectedListItem: {
    '&:hover': {
      borderRight: '8px solid #DF0C36',
    },
    '&:focus': {
      background: '#F8F8F8',
      borderRight: '8px solid #DF0C36',
    },
  },
  icon: {
    minWidth: '40px',
  },
  array: {
    color: '#DF0C36',
  },
}));
